module.exports = __webpack_public_path__ + "9b1206aa19fabb73e9fa63884be5fa4b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/superman_s_symbol.svg
// module id = 2752
// module chunks = 0